<template>
  <div id="footerx_content">
    <v-container class="footerx">
      <v-row
        class="top-flex-row d-flex flex-row justify-space-between align-center"
      >
        <v-col cols="12" lg="8" class="pa-0 d-flex justify-start align-center">
          <img
            src="../images/webclip.png"
            loading="lazy"
            E
            alt=""
            class="nav_logo mr-4" />
          <a
            href="https://www.facebook.com/RenoPoliceDepartment"
            target="_blank"
            rel="noopener"
            class="mr-4"
            ><img src="../images/fb-icon.png"
          /></a>
          <a
            href="https://www.instagram.com/reno_police"
            target="_blank"
            rel="noopener"
            class="mr-4"
            ><img src="../images/insta-icon.png"
          /></a>
          <a
            href="https://x.com/renopolice"
            target="_blank"
            rel="noopener"
            class="mr-4"
            ><img src="../images/x-icon.png"
          /></a>
          <a
            href="https://www.youtube.com/@RenoPoliceDepartment"
            target="_blank"
            rel="noopener"
            class="mr-4"
            ><img src="../images/youtube-icon.png" /></a
        ></v-col>
        <v-col cols="12" lg="4">
          <p>© 2024 Copyright Reno Police Department. All Rights Reserved.</p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
/* 0 media q */
@media (min-width: 0px) {
  #footerx_content {
    width: 100%;
    backdrop-filter: blur(10px);
    z-index: 1;
  }
  .footerx {
    background-color: #ba9c58e6;
    height: 88px;
    width: 100%;
    max-width: 100%;
  }

  .container {
    padding: 0 !important;
  }

  .top-flex-row {
    width: 94%;
    margin: 0 auto;
    height: 88px;
  }

  .footerx a img {
    width: 40px;
    height: auto;
  }

  .nav_logo {
    width: 80px;
  }

  p {
    font-size: 1rem;
    text-align: center;
    font-family: Inter Tight, sans-serif;
  }

  // button css
  .button.is-small {
    padding: 0.5rem 1.25rem;
    font-size: 1.5rem;
  }
  .button {
    border: 1px solid white;
    background-color: #ba9c58;
    color: #fff !important;
    text-align: center;
    font-family: Oswald;
    text-transform: uppercase;
    padding: 2rem 2rem !important;
    font-size: 1.75rem;
    font-weight: 600;
    text-decoration: none;
  }
  .w-button {
    display: inline-block;
    padding: 9px 15px;
    background-color: #3898ec;
    color: white;
    border: 0;
    line-height: inherit;
    text-decoration: none;
    cursor: pointer;
    border-radius: 0;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  // #footerx_content {
  //   height: 190px;
  // }

  .v-size--default {
    font-size: 0.85rem;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  // #footerx_content {
  //   height: 135px;
  // }
}

/* 1440 media q */
@media (min-width: 1440px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "footerx",
  mixins: [bus_common],
  data() {
    return {
      drawer: false,
      group: null,
    };
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    message2() {
      alert("This button will take the user to the appropriate page.");
    },
    init() {},
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
